"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("listing-list-page", className, styles.root),
        header: styling_1.mergeStyles("listing-list-page-header", styles.header),
        body: styling_1.mergeStyles("listing-list-page-body", styles.body)
    };
});
exports.getClassNames = getClassNames;
